import React from 'react';
import PropTypes from 'prop-types';
import { AddReferencia as AppAddReferencia } from './styles';

export default class AddReferencia extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    onClick: PropTypes.func,
    icon: PropTypes.string,
    disabled: PropTypes.bool,
    noIcon: PropTypes.bool,
    type: PropTypes.string,
    button: PropTypes.string,
    noTitle: PropTypes.bool,
    classes: PropTypes.string,
    backgroundType: PropTypes.oneOf(['primary', 'light', 'secondary']),
  };

  static defaultProps = {
    title: '',
    onClick: () => {},
    icon: 'plus',
    disabled: false,
    noIcon: false,
    noTitle: false,
    type: 'button',
    button: '',
    classes: '',
    backgroundType: 'primary',
  };

  render() {
    return (
      <AppAddReferencia backgroundType={this.props.backgroundType} type={this.props.type}
      style={{
        height:'40px',margin:'16px 0px',
        width:'100%',
        borderRadius:'8px',
        fontFamily: 'Public Sans',
        fontSize: '16px',
        fontWeight: 700,
        lineHeight: '24px',
        letterSpacing: '0em',
        textAlign: 'center'}} onClick={this.props.onClick} disabled={this.props.disabled}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
          <i style={{fontSize:'24px', marginRight:'4px'}} className='icon-Plus'></i> <span style={{fontWeight:700, fontFamily:'Public Sans',fontSize:'16px'}}>{this.props.title}</span>
        </div>

      </AppAddReferencia>
    );
  }
}
